import type { StaticImageData } from 'next/image';
import imageMessisCover from '@/images/messis-dagbok/cover.png';
import imageLanaCover from '@/images/lana-eller-lina/cover.png';
import { SKU_IMAGE_KEYS } from '@sapling/constants/products';

const IMAGE_MAP: Record<string, StaticImageData> = {
  'messis-dagbok-cover': imageMessisCover,
  'lana-eller-lina-cover': imageLanaCover,
};

/** Resolve an imageKey (from product catalog) to a StaticImageData. */
export function resolveProductImage(key: string): StaticImageData | undefined {
  return IMAGE_MAP[key];
}

/** Resolve a product SKU to its primary image (for cart display). */
export function resolveProductImageBySku(
  sku: string,
): StaticImageData | undefined {
  const imageKey = SKU_IMAGE_KEYS[sku];
  return imageKey ? IMAGE_MAP[imageKey] : undefined;
}
